export default __webpack_public_path__ + "static/media/9.37f632bb.png";